import { ActionReducerMap } from '@ngrx/store';

import * as fromState from './state.reducer';
import * as fromChange from './change.reducer';
import { ManageBookingState } from '../../interfaces/store.interface';
import { checkInReducer } from './check-in.reducer';

export const reducers: ActionReducerMap<ManageBookingState> = {
  state: fromState.reducer,
  change: fromChange.reducer,
  checkIn: checkInReducer,
};
